import API, { getAccessToken } from "./baseApi";
import axios from "axios";

const getAllClients = (payload) => {
  if (payload && Object.keys(payload).length) {
    let query = "?";
    Object.keys(payload).map((x) => {
      if (payload[x] !== undefined && payload[x] !== null) {
        let value = payload[x];
        if (typeof value === "object") {
          value = JSON.stringify(value);
        }
        query = query + `${x}=${value}&`;
      }
    });
    return API.get("/clients" + query, payload);
  } else {
    return API.get("/clients", payload);
  }
};

const createClients = (payload) => {
  return API.post("/clients", payload);
};

const updateClients = (id, payload) => {
  return API.put(`/clients/${id}`, payload);
};

const deleteClients = (id, payload) => {
  return API.delete(`/clients/${id}`, payload);
};

const getAllTenants = (payload) => {
  return API.get("/clients/getTenants");
};

const getAllCountries = (payload) => {
  return API.post("/countries/allData");
};

const uploadMedia = (formData, tenant) => {
  // Determine tenant id: prefer explicit tenant param, otherwise use selectedClient from store, fall back to 'hdfc'
  const { store } = require("../store/store");
  const selectedClient = store?.getState()?.clients?.selectedClient?.value;
  const tenantId = tenant || selectedClient || "hdfc";

  // Compute token using baseApi helper so we reuse the same mapping logic
  const token = getAccessToken(tenantId);

  // Build absolute URL for media endpoint
  const baseURL = process.env.REACT_APP_PL_API || "";
  const url = `${baseURL.replace(/\/$/, "")}/media`;

  // Post with axios directly so we can control multipart headers and bypass interceptors
  return axios.post(url, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      "x-tenant-id": tenantId,
      "x-access-token": token,
    },
    withCredentials: true,
  });
};

const getAddOnMaster = (payload) => {
  return API.post("/addOn/getMaster",payload);
};

const createAddOnMaster = (payload) => {
  return API.post("/addOn/create", payload);
};

const updateAddOnMaster = (id, payload) => {
  return API.put(`/addOn/${id}`, payload);
};

const deleteAddOnMaster = (id) => {
  return API.delete(`/addOn/${id}`);
};

export default {
  getAllClients,
  createClients,
  updateClients,
  deleteClients,
  getAllTenants,
  getAllCountries,
  uploadMedia,
  getAddOnMaster,
  createAddOnMaster,
  updateAddOnMaster,
  deleteAddOnMaster
};
